import { apiService } from '@/services/api'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { ScanShape } from '@/types'

export const useProductStore = defineStore('product', () => {
    const isLoading = ref(false)
    const error = ref<string | null>(null)

    const recognizeProduct = async (imageFile: File, shape?: ScanShape) => {
        try {
            isLoading.value = true
            error.value = null

            const response = await apiService.recognizeProduct(imageFile, shape)
            if (response.success && response.data) {
                return { success: true, data: response.data }
            } else {
                error.value = response.error?.message || 'Ошибка распознавания продукта'
                return { success: false, error: response.error }
            }
        } catch (err: unknown) {
            error.value = (err as Error)?.message || 'Ошибка распознавания продукта'
            return { success: false, error: { code: -1, message: error.value } }
        } finally {
            isLoading.value = false
        }
    }

    return {
        isLoading,
        error,
        recognizeProduct,
    }
})
